import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const TarjetasResumenKPI = ({ resumen, estatusBorrado }) => {
    // Si estamos en "Ya Programadas", mostramos 3 columnas equitativas. Si no, 4 columnas.
    const colSize = estatusBorrado === 1 ? 4 : 3;

    return (
        <Row className="g-2 mb-3">
            <Col sm={colSize}>
                <Card className="border-danger border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">Total Candidatas</h6>
                        <h3 className="mb-0 text-danger">{resumen?.iTotalCandidatas || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={colSize}>
                <Card className="border-primary border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">Licencias Nube</h6>
                        <h3 className="mb-0 text-primary">{resumen?.iTotalNube || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            <Col sm={colSize}>
                <Card className="border-info border-top border-4">
                    <Card.Body className="py-2 px-3">
                        <h6 className="text-700 mb-1">Licencias AkasiaPOS</h6>
                        <h3 className="mb-0 text-info">{resumen?.iTotalAkasiaPOS || 0}</h3>
                    </Card.Body>
                </Card>
            </Col>
            {estatusBorrado === 0 && (
                <Col sm={colSize}>
                    <Card className="border-warning border-top border-4">
                        <Card.Body className="py-2 px-3">
                            <h6 className="text-700 mb-1">Empresas con Ambas</h6>
                            <h3 className="mb-0 text-warning">{resumen?.iTotalAmbas || 0}</h3>
                        </Card.Body>
                    </Card>
                </Col>
            )}
        </Row>
    );
};

export default TarjetasResumenKPI;
